<template>
  <router-link class="tryout" :to="`/tryout/${id}`">
    <div class="tryout__avatar">
      <app-icon :variant="type"></app-icon>
    </div>
    <div class="tryout__info">
      <div class="tryout__team">{{ team }}</div>
      <div class="tryout__dates">
        {{ datesString }}
      </div>
    </div>
  </router-link>
</template>

<script>
import moment from 'moment'
import AppIcon from '@/components/AppIcon.vue'

export default {
  components: {
    AppIcon,
  },
  computed: {
    datesString() {
      return this.dates.map(d => moment(d).format('MMMM D')).join(', ')
    },
  },
  props: {
    dates: {
      type: Array,
      default: () => [],
    },
    id: {
      type: String,
      default: '',
    },
    team: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'target',
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/variables';

.tryout {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  text-decoration: none;

  &:hover {
    background: $colorBackgroundDark;
  }

  &__avatar {
    align-self: start;
    background: $colorForeground;
    border-radius: 3px;
    height: 40px;
    padding: 4px;
    width: 40px;
  }

  &__dates {
    font-style: italic;
  }

  &__team {
    font-weight: 700;
  }
}
</style>
